const initialState = {
    token: null,
    destinationsType1: [],
    destinationsType2: [],
    destinationsType3: [],
    selectedPackage: {},
    packageType1: [],
    packageType2: [],
    packageType3: [],
    packageResp: {}
};

export default function esimReducer(state = initialState, action) {
    switch (action.type) {
        case 'SET_ESIM_TOKEN':
            return {
                ...state,
                token: action.payload
            };

        case 'SET_DESTINATIONS_TYPE_1':
            return {
                ...state,
                destinationsType1: action.payload
            };

        case 'SET_DESTINATIONS_TYPE_2':
            return {
                ...state,
                destinationsType2: action.payload
            };

        case 'SET_DESTINATIONS_TYPE_3':
            return {
                ...state,
                destinationsType3: action.payload
            };
        case 'SET_PACKAGES_TYPE_1':
            return {
                ...state,
                packageType1: action.payload
            };
        case 'SET_PACKAGES_TYPE_2':
            console.log(action.payload)
            return {
                ...state,
                packageType2: action.payload
            };
        case 'SET_PACKAGES_TYPE_3':
            return {
                ...state,
                packageType3: action.payload
            };
        case 'SET_PACKAGE_RESP':
            return {
                ...state,
                packageResp: action.payload
            };
        case 'RESET_ESIM':
            return initialState;

        default:
            return state;
    }
}
